import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FairBalanceIssue } from "../issues/factory/model/fair-balance-issue.models";
import { EmbeddedObjectAnnotation } from "@shared/models/embedded-object-annotation";
import { DrawerDetails } from "@shared/models/common";
import { IndPhrase } from "@shared/models/cat.model";
import { RevRule } from "@shared/models/rev.model";

@Component({
    selector: 'fair-balance-issues',
    templateUrl: './fair-balance-issues.component.html',
    styleUrls: ['./fair-balance-issues.component.scss'],
    standalone: false
})
export class FairBalanceIssues {


    @Input() fairBalanceIssues: FairBalanceIssue[];

    @Input() phrase: IndPhrase | RevRule = null;

    @Input() disableActions: boolean = false;
    
    @Output() removeFairBalanceIssueEvent = new EventEmitter<FairBalanceIssue>();

    @Output() viewFairBalanceIssueEvent = new EventEmitter<DrawerDetails>();

    viewerObject: {type: string; data: EmbeddedObjectAnnotation | DrawerDetails} = null;

    removeFairBalanceIssue(issue: FairBalanceIssue) {

      let indexOf = this.fairBalanceIssues.findIndex( fb => fb.issueId == issue.issueId);
      if (indexOf > -1) {
        this.fairBalanceIssues.splice(indexOf, 1);
      }
      issue.remove(this.phrase);

      this.removeFairBalanceIssueEvent.emit();

    }

    viewFairBalanceIssue(issue: FairBalanceIssue) {

      this.viewerObject = issue.view();

      if (this.viewerObject.type === 'FAIR_BALANCE_ISSUE_STANDALONE') {  

        this.viewFairBalanceIssueEvent.emit(this.viewerObject.data as DrawerDetails);

      }
  }

  getCategoryClass(category: string): string {
    return category
      ? `fair-balance-issues-category-pill--${category.trim().toLowerCase()}`: '';
  }

}